import { ApiResource } from './apiResource';

export class ExcelDownloadApi extends ApiResource {
  async postExcelsClinic(params: any) {
    return this.client.post('/admin/excels/clinic', params);
  }

  async getTasks(id: number) {
    return this.client.get(`/admin/tasks/${id}`);
  }

  async downloadExcel(location: string, name: string) {
    return this.client.get(`${location}/download`, { name: name });
  }

  // 관리자 문자충전 엑셀 요청
  async postExcelsSms(params: any) {
    return this.client.post('/admin/excels/balance', params);
  }
}
